import React, { useState } from 'react';
import PropTypes from "prop-types";
import BrightcovePlayer from '@components/video/brightcove_player/main';
import VideoJSPlayer from '@components/video/videojs_player/main';
import DownloadOptions from './download_options';

import './styles/main'

function AdvancedVideoEditor(props) {
  const [player, setPlayer] = useState(undefined);

  const onSuccess = (player) => {
    setPlayer(player);
  };

  const renderVideoPlayer = () => {
    let { vendor } = props;
    let videoOptions;

    if (vendor === 'brightcove') {
      videoOptions = {
        attrs:     { id: 'brightcove-advanced-video-editor-modal' },
        accountID: props.video.accountID,
        videoID:   props.video.videoID,
        playerID:  props.video.playerID,
        onSuccess: (event) => { onSuccess(event.ref) }
      }

      return (
        <div className="advanced-editor-modal">
          <div id='advanced-video' className="m-show-full-size-display s-expand-view" controls>
            <BrightcovePlayer { ...videoOptions } />
          </div>
          <DownloadOptions {...props} player={player} />
        </div>
      )
    } else {
      videoOptions = {
        sources: [props.video],
        onSuccess: (player) => { onSuccess(player) }
      };

      return (
        <div className="advanced-editor-modal">
          <div id='advanced-video' className="m-show-full-size-display s-expand-view" controls>
            <VideoJSPlayer className="m-show-full-size-display" { ...videoOptions } />
          </div>
          <DownloadOptions {...props} player={player} />
        </div>
      )
    }
  }

  return renderVideoPlayer();
}

AdvancedVideoEditor.propTypes = {
  vendor: PropTypes.oneOf(['mux', 'brightcove']).isRequired,
  video:  PropTypes.oneOfType(
    [
      // Mux video
      PropTypes.shape({
        src:  PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
      // Brightcove video
      PropTypes.shape({
        accountID: PropTypes.string,
        videoID:   PropTypes.string,
        playerID:  PropTypes.string
      })
    ]
  ).isRequired,
  attachment: PropTypes.shape({
    key:       PropTypes.string,
    extension: PropTypes.string,
    height:    PropTypes.number,
    filename:  PropTypes.string
  }).isRequired,
  assetKey: PropTypes.string.isRequired,
};

export default AdvancedVideoEditor;
